import _ from 'lodash';
import Fa from '../../utils/Fa';

interface RatingStarsProps {
  rating: number;
}

export default function RatingStars({ rating }: RatingStarsProps): JSX.Element {
  return (
    <>
      {_.range(1, 6).map((index) => (
        <Fa key={index} icon={index <= rating ? 'star' : 'star-o'} aria-hidden="true" />
      ))}
    </>
  );
}
